var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / jam-icons / outline & logos / facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1514 8.36943V12.2909H10.2773V17.0857H13.1514V31.3359H19.0507V17.0871H23.0106C23.0106 17.0871 23.3817 14.7882 23.5615 12.2738H19.0749V8.99447C19.0749 8.505 19.7171 7.84572 20.3535 7.84572H23.57V2.854H19.1976C13.0044 2.854 13.1514 7.65307 13.1514 8.36943Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0918eba769e80a38a049defd3067f13b.svg";
export { ForwardRef as ReactComponent };